export default __webpack_public_path__ + "static/media/38_mobile.90b2f9a4.jpg";